<template>
  <div class="search-news-box">
    <router-link :to="'/news/'+p_id">
    <div class="box-number">
      {{(10>Number(p_id))?("0"+String(Number(p_id)+1)):(String(Number(p_id)+1))}}
    </div>
    <div class="box-content">
      <div class="box-title">
        {{title}}
      </div>
      <div class="box-url">
        http://localhost:8080/news/{{p_id}}
      </div>
      <div class="box-text">
        {{text}}
      </div>
    </div>
    <div class="box-image">
      <img :src="require('@/assets/news/'+imgSrc)">
    </div>
    </router-link>
  </div>
</template>

<script>
import users from '../../assets/news/news-list.json'

export default {
  name: 'searchNewsBox',
  props: {
    p_id: String
  },
  data () {
    return {
      title: users[this.p_id]['title'],
      imgSrc: users[this.p_id]['imgSrc'],
      text: users[this.p_id]['text']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .search-news-box{
    width: 100%;
    padding-top: 1vw;
    padding-bottom: 1vw;

    a,a:visited{
      text-decoration: none;
      width: 100%;

      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
  .box-number{
    display: flex;
    color: #9FA0A0;
    font-weight: bolder;
    padding-top: 1vw;
    padding-bottom: 1vw;
    font-size: 2.8vw;
    font-weight: 700;
  }
  .box-content{
    text-align: left;
    padding-top: 1vw;
    padding-bottom: 1vw;
    width: 37.3vw;
  }
  .box-title{
    color: #333333;
    font-size: 1.2vw;
    font-weight: bolder;
  }
  .box-url{
    color: #D0AF1F;
    font-size: .5vw;
    padding-top: .5vw;
    padding-bottom: .5vw;
  }
  .box-text{
    color: #333333;
    font-size: .7vw;
    line-height: 2vw;
  }
  .box-image{
    width: 9.3vw;
    padding-top: 1vw;
    padding-bottom: 1vw;
    img{
      width: 100%;
      height: auto;
    }
  }
  @media (max-width: 550px) {
    .box-number{
      position: relative;
      top: -10px;
      left: 0;
      font-size: 40px;
      padding-top: 0;
    }
    .box-content{
      width: 78%;
      position: relative;
      top: -75px;
      right: -90px;

    }
    .box-title{
      font-size: 20px;
    }
    .box-url{
      font-size: 13px;
    }
    .box-text{
      margin-top: 7px;
      font-size: 15px;
      overflow: hidden;
      height: 5em;
      line-height: 1.7em;
    }
    .box-image{
      width: 78%;
      position: relative;
      top: -75px;
      right: -90px;
      height: 50vw;
      overflow: hidden;
    }
    .search-news-box{
      padding: 30px 0;

      a,a:visited{
        display: flex;
        flex-direction: column;
        margin-bottom: -80px;
      }
    }
  }

</style>
